import React from "react";
import {Pagination} from "react-admin";

export const OrderPagination = (props: any) => (
    <Pagination
        rowsPerPageOptions={[25, 50, 100]}
        {...props}
    />
);
